import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import UserWithAvatar from "components/Atoms/UserWithAvatar";

type Props = RemovableProps<server.dto.UserSmall>;

export const RemovableUser = (props: Props) => {
  return <RemovableLabel
    {...props}
  >
    <UserWithAvatar user={props.value} avatarSize="avatar-30" />
  </RemovableLabel>;
};